import { CreateAttendanceRecurrenceParams } from '../types'

export class CreateAttendanceRecurrenceMapper {
  static toPersistence(params: CreateAttendanceRecurrenceParams) {
    return {
      idAtendimento: params.attendanceId,
      frequenciaRecorrencia: params.recurrencePeriodValue,
    }
  }
}
